import { Wallet } from 'modules/organizer/domain/interfaces/wallet';

export interface WalletDto {
  id: number;
  balanceInMinorUnits: number;
}

export function mapWallet(dto: WalletDto): Wallet {
  return {
    id: dto.id,
    balanceInMinorUnits: dto.balanceInMinorUnits,
  };
}
